const FETCH_MARKET_ITEMS = 'market/FETCH_MARKET_ITEMS';
const PURCHASE_MARKET_ITEM = 'market/PURCHASE_MARKET_ITEM';
const FETCH_MY_MARKET_INVENTORIES = 'market/FETCH_MY_MARKET_INVENTORIES';
const USE_MARKET_INVENTORY = 'market/USE_MARKET_INVENTORY';

const REMOVE_OPTION = 'market/REMOVE_OPTION';

const FETCH_MARKET_CURATIONS = 'market/FETCH_MARKET_CURATIONS';

export default {
  FETCH_MARKET_ITEMS,
  PURCHASE_MARKET_ITEM,
  FETCH_MY_MARKET_INVENTORIES,
  USE_MARKET_INVENTORY,
  REMOVE_OPTION,
  FETCH_MARKET_CURATIONS,
};



// WEBPACK FOOTER //
// ./src/app/redux/front/market/types.js